module.exports = __webpack_public_path__ + "/images/ico-star-fill.20f6b48.svg";